import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Divider,
  Table,
  TableBody,
  TableRow,
  TableCell,
  colors
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import EditTimetable from '../../EditTimetable/EditTimetable';

const useStyles = makeStyles(theme => ({
    root: {},
    
    content: {
        padding: 0
    },

    actions: {
        flexDirection: 'column',
        alignItems: 'flex-end',
            '& > * + *': {
            marginLeft: 0
        }
    },

    buttonIcon: {
        marginRight: theme.spacing(1)
    },

    editButton: {
        color: theme.palette.white,
        backgroundColor: colors.blue[600],
        '&:hover': {
        backgroundColor: colors.blue[900]
        }
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
      },
    
}));

export default function DetailData(props) {

    const { bookings, className, ...rest } = props;

    const classes = useStyles();
  
    const [openEdit, setOpenEdit] = useState(false);
  
    const handleEditOpen = () => {
      setOpenEdit(true);
    };
  
    const handleEditClose = () => {
      setOpenEdit(false);
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader title="Booking Detail" />
            <Divider />
            <CardContent className={classes.content}>
                <Table>
                    <TableBody>
                    <TableRow>
                        <TableCell>Slots</TableCell>
                        <TableCell>
                            {bookings.slots}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Day</TableCell>
                        <TableCell>{bookings.day}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Start Time</TableCell>
                        <TableCell>{bookings.starttime}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>End Time</TableCell>
                        <TableCell>{bookings.endtime}</TableCell>
                    </TableRow>
                    
                    
                    </TableBody>
                </Table>
            </CardContent>
            <CardActions className={classes.actions}>
                <Button className={classes.editButton} onClick={handleEditOpen}>
                <EditIcon className={classes.leftIcon}/>
                    Edit
                </Button>
               
            </CardActions>
            <EditTimetable
                bookings={bookings}
                onClose={handleEditClose}
                open={openEdit}
            />
        </Card>
    );
}
